/**
 * Shared validator for env var name pointer fields.
 *
 * Matches the backend Pydantic validator on
 * FacilityBase.stripe_secret_env_var / .resend_env_var (Pattern A).
 * Format: POSIX-ish — uppercase letter first, then any combo of
 * uppercase letters, digits, and underscores.
 *
 * Empty / null / undefined are valid — semantically "leave blank to use
 * the platform default".
 */

const ENV_VAR_NAME_RE = /^[A-Z][A-Z0-9_]*$/;

export const isValidEnvVarName = (name) => {
  if (name === null || name === undefined || name === '') return true;
  if (typeof name !== 'string') return false;
  return ENV_VAR_NAME_RE.test(name);
};
